module.exports = __webpack_public_path__ + "manual-newProject.png?d2aa0503c175ef0a84eb1a9b2d225b01";


//////////////////
// WEBPACK FOOTER
// ./src/images/manual-newProject.png
// module id = 406
// module chunks = 0